module.exports = __webpack_public_path__ + "img/1.967efe3b.jpg";